import React from 'react';
import PropTypes from 'prop-types';
import { FormControlLabel, RadioGroup, Radio } from '@mui/material';

import './custom-radio-select.styles.scss';

import HoverPopper from '../hover-popper/hover-popper.component';

export default function CustomRadioSelect({
  title,
  value,
  changeFunction,
  options
}) {
  let opts = null;
  let groupedOptions = null;
  if (Array.isArray(options)) {
    opts = options;
  } else if (options !== null && options.constructor.name === 'Object') {
    groupedOptions = options;
  }

  if (opts || groupedOptions) {
    return (
      <div className='radio-select-container'>
        <div className='radio-select-title'>{title}</div>
  
        <RadioGroup
          value={value}
          onChange={(e) => changeFunction(e.target.value)}
          className='radio-btns-container'
        >
          {groupedOptions ? 
            Object.keys(groupedOptions).map(gName => {
              return (
                <React.Fragment key={gName}>
                  {gName.slice(0,4) === 'none' ? '' : <div className='radio-select-title' style={{ left: 0 }}>{gName}</div>}
                  {groupedOptions[gName].map((option) => (
                    <FormControlLabel
                      key={option}
                      value={option}
                      control={<Radio className='radio-btn' />}
                      label={option}
                    />
                  ))}
                </React.Fragment>
              );
            })
            :
            opts.map((option) => (
              <FormControlLabel
                key={option}
                value={option}
                control={<Radio className='radio-btn' />}
                label={option === 'Normal' ? <HoverPopper
                  key='normal-hover-popper'
                  popperText='"Normal" is the past 30 year period'
                >Normal</HoverPopper> : option}
              />
            ))
          }
        </RadioGroup>
      </div>
    );
  }
  return <></>;
}

CustomRadioSelect.propTypes = {
  title: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  changeFunction: PropTypes.func,
  options: PropTypes.oneOfType([PropTypes.array, PropTypes.object])
};
